<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header :title="`${item.group_name} - ${item.name}`" subtitle="Update the details for this labour rate here.">
            <template #actions>
                <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <!-- Data grid. -->
        <ui-data-grid>
            <ui-data-grid-item label="Units Per Hour">{{ item.unit_per_hour }}</ui-data-grid-item>

            <ui-data-grid-separator />

            <labour-rates-rate-card
                v-if="item.can_view.buy_rate"
                title="Buy Rates"
                subtitle="The costs that you buy this type of labour in for."
                :uom="item.uom"
                :unitsPerHour="parseFloat(item.unit_per_hour)"
                :hoursInDay="parseFloat(item.buy_hours_in_shift)"
                :dailyRate="parseFloat(item.buy_day_rate)"
            />

          <labour-rates-rate-card
              v-if="item.can_view.sell_rate"
              title="Sell Rates"
              subtitle="The costs that you sell this type of labour for."
              :uom="item.uom"
              :unitsPerHour="parseFloat(item.unit_per_hour)"
              :hoursInDay="parseFloat(item.sell_hours_in_shift)"
              :dailyRate="parseFloat(item.sell_day_rate)"
          />

          <ui-data-grid-item label="Created By">{{ item.created_by }} on {{ item.created_at }}</ui-data-grid-item>
          <ui-data-grid-item label="Last Updated By">{{ item.updated_by }} on {{ item.updated_at }}</ui-data-grid-item>
        </ui-data-grid>

    </ui-container>
</template>

<script>
import UiDataGridSeparator from "../ui/UiDataGridSeparator";
import LabourRatesRateCard from "./LabourRatesRateCard";
export default {
  components: {LabourRatesRateCard, UiDataGridSeparator},
  props: {
        item: Object,
        edit: Function,
        removeItem: Function,
    },
    methods: {
        openDeleteModal () {
            const title = 'Are you sure you want to remove this labour rate?'
            const description = 'You are removing the labour rate "' + this.item.name + '". Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
    },
}
</script>
